export default __webpack_public_path__ + "static/media/vocal jodida_1.d78767a3.wav";